//import './utils/whyDidYouRender';
//import 'promise-polyfill/src/polyfill';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { defaultTheme } from 'themes/default';

import { getWebVersion } from 'components/utils/app';
import { MemberProvider } from 'hooks/member';
import { AppProvider, CardNavProvider, QueryDictProvider } from 'hooks/app';

import BirthdayAlarmApp from 'app';

import 'normalize.css';
import './bday-react.scss';

const reactAppContainer = document.getElementById('bday-react-app');
const root = createRoot(reactAppContainer);

global.version = getWebVersion();
console.info(`===== BirthdayAlarm WebApp - ${global.version} =====`);

root.render(
  <AppProvider>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={defaultTheme}>
        <Router>
          <QueryDictProvider>
            <MemberProvider>
              <CardNavProvider>
                <BirthdayAlarmApp/>
              </CardNavProvider>
            </MemberProvider>
          </QueryDictProvider>
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  </AppProvider>
);
